export default __webpack_public_path__ + "static/media/credit_card_payment.294062b0.svg";